import React from "react";
import { DateTime } from "luxon";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Card,
  CardContent,
  CardActions,
  Stack,
  Divider,
  Chip,
  Button,
} from "@mui/material";
import { Close as CloseIcon, Schedule } from "@mui/icons-material";

const ExpiredExpeditedRequestModal = ({
  open,
  onClose,
  selectedJob,
  currentUser,
  onAccept,
}) => {
  if (!selectedJob) return null;

  const formatDateTime = (value) => {
    if (!value) return "N/A";

    const dt =
      typeof value === "number"
        ? DateTime.fromSeconds(value, { zone: "utc" })
        : DateTime.fromISO(value, { zone: "utc" });

    if (!dt.isValid) return "N/A";
    return dt
      .setZone(currentUser?.timezone || "America/New_York")
      .toFormat("MMMM dd, yyyy hh:mm a");
  };

  const signer = selectedJob?.signer || "N/A";

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "95%", md: "70%", lg: "55%" },
          maxWidth: "760px",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 2,
          maxHeight: "90vh",
          overflow: "hidden",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 10, top: 10, zIndex: 1 }}
        >
          <CloseIcon />
        </IconButton>

        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            maxHeight: "90vh",
          }}
        >
          <CardContent sx={{ p: 3, overflowY: "auto" }}>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
              Expired Expedited Request
            </Typography>

            <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
              <Chip
                label="Expedited"
                color="error"
                size="small"
                sx={{ fontWeight: 600 }}
              />
              <Chip
                label={signer.charAt(0).toUpperCase() + signer.slice(1)}
                color={signer === "owner" ? "primary" : "secondary"}
                size="small"
              />
            </Stack>

            <Divider sx={{ mb: 2 }} />

            <Stack spacing={1.5}>
              <Typography variant="body2">
                <strong>Requested At:</strong>{" "}
                {formatDateTime(selectedJob?.requested_created_at)}
              </Typography>
              <Typography variant="body2">
                <strong>Expired At:</strong>{" "}
                {formatDateTime(selectedJob?.expired_at)}
              </Typography>
              <Typography variant="body2">
                <strong>Requester:</strong>{" "}
                {selectedJob?.requester?.full_name || "N/A"}
              </Typography>
              <Typography variant="body2">
                <strong>Email:</strong> {selectedJob?.requester?.email || "N/A"}
              </Typography>
              <Typography variant="body2">
                <strong>Phone:</strong> {selectedJob?.requester?.phone || "N/A"}
              </Typography>
              <Typography variant="body2">
                <strong>Project Address:</strong>{" "}
                {selectedJob?.project_address || "N/A"}
              </Typography>
              <Typography variant="body2">
                <strong>Package ID:</strong> {selectedJob?.task_id || "N/A"}
              </Typography>
            </Stack>
          </CardContent>

          <CardActions
            sx={{
              p: 2,
              justifyContent: "flex-end",
              borderTop: "1px solid",
              borderColor: "divider",
            }}
          >
            <Button variant="outlined" onClick={onClose}>
              Close
            </Button>
            <Button
              variant="contained"
              color="success"
              startIcon={<Schedule />}
              onClick={() => onAccept(selectedJob)}
            >
              Accept
            </Button>
          </CardActions>
        </Card>
      </Box>
    </Modal>
  );
};

export default ExpiredExpeditedRequestModal;
